<template>
  <div class="stages-legend">
    <template v-for="(stage, i) in stages">
      <div
        :key="stage.name"
        :class="{ 'stages-legend__stage_red': stage.finished || stage.active }"
        class="stages-legend__stage"
      >
        <div class="stages-legend__stage-index">{{ i + 1 }}</div>
        <div class="stages-legend__stage-title">{{ stage.name }}</div>
      </div>
      <div
        v-if="!checkLastStage(i)"
        :key="`${stage.name}_pb`"
        :class="{ 'stages-legend__progress-bar_active': stage.active, 'stages-legend__progress-bar_red': stage.finished }"
        class="stages-legend__progress-bar"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    stages: {
      type: Array,
      required: true,
      validator(arrVals) {
        return arrVals.every(val => typeof val.name === 'string') && arrVals.some(val => val.active);
      },
    },
  },
  methods: {
    checkLastStage(i) {
      return this.stages.length === (i + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.stages-legend {
  width: 297px;
  display: flex;
  height: 57px;
  align-items: flex-start;;
  &__stage {
    z-index: 5;
    position: relative;
    &_red {
      .stages-legend__stage-index {
        border-color: $red-color3;
      }
      .stages-legend__stage-title {
        color: $red-color3;
      }
    }
  }
  $stage-diameter: 25px;
  &__stage-index {
    width: $stage-diameter;
    height: $stage-diameter;
    border: 2px solid $white-color5;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 13px;
    line-height: 11px;
    transition: $transition border-color ease-out $transition;
  }
  &__stage-title {
    @include font(17px, $black-color1, 500);
    position: absolute;
    bottom: -31px;
    white-space: nowrap;
    transition: color $transition ease-out $transition;
  }
  &__progress-bar {
    z-index: 0;
    width: calc(100% - #{$stage-diameter * 2});
    margin-top: 11px;
    height: 2px;
    background: $white-color5;
    position: relative;
    overflow: hidden;
    &:after {
      content: '';
      transition: width $transition ease-out;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 0%;
      background: linear-gradient(to right, $red-color3 0%,$white-color5 100%);
    }
    &_active {
      &:after {
        transition-delay: $transition * 1.5;
        width: 35%;
      }
    }
    &_red {
      &:after {
        transition-duration: $transition * 3;
        width: 300%;
      }
    }
  }
}
@media only screen and (max-width : 540px) {
  .header-block {
    .stages-legend_stage2 .stages-legend__stage-title {
      margin-left: -96px;
    }
  }
}

@media only screen and (max-width: $phone-change-popup-mobile-bp) {
  .phone-change-popup {
    .stages-legend_stage2 .stages-legend__stage-title {
      margin-left: -63px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/uikit/StagesLegend.vue